import { DashboardCreated } from '../components';
import Frame from '../layout/Frame';
import Panel from '../layout/Panel';

const DashboardAdded = () => {
  return (
    <Frame>
      <Panel>
        <h1>NEW DASHBOARD ADDED SUCCESSFULLY</h1>
        <DashboardCreated />
      </Panel>
    </Frame>
  );
};

export default DashboardAdded;
